module.exports = __webpack_public_path__ + "static/media/bg-featured-tile.5e4ead74.jpg";